/**
 * The four lanes a webhook-delivered file is routed through after
 * classification.
 */
export var FileLane;
(function (FileLane) {
    FileLane["Commitment"] = "commitment";
    FileLane["Playbook"] = "playbook";
    FileLane["Knowledge"] = "knowledge";
    FileLane["Drop"] = "drop";
})(FileLane || (FileLane = {}));
/**
 * Sub-classification for files routed to the Knowledge lane. The lane
 * itself decides the S3 prefix; `KnowledgeKind` only influences the
 * Dendron filename the classifier proposes (e.g. a `Contract` doc lands
 * at `knowledge/<customer>.<deal>.contract.md`, such as
 * `knowledge/acme.q4-renewal.contract.md`).
 */
export var KnowledgeKind;
(function (KnowledgeKind) {
    KnowledgeKind["Contract"] = "contract";
    KnowledgeKind["Postmortem"] = "postmortem";
    KnowledgeKind["StatusReport"] = "status_report";
    KnowledgeKind["DealNote"] = "deal_note";
    KnowledgeKind["EmailThread"] = "email_thread";
    KnowledgeKind["Spec"] = "spec";
    KnowledgeKind["RfpResponse"] = "rfp_response";
    KnowledgeKind["Other"] = "other";
})(KnowledgeKind || (KnowledgeKind = {}));
